import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("AdminPermissions")
export class AdminPermissions {
    static readonly None = 0;
    static readonly SIS = 1;
    static readonly Import = 2;
    static readonly Survey = 4;
    static readonly Customize = 8;
}
